var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list', {
    attrs: {
      "nav": "",
      "dense": ""
    }
  }, [_c('v-list-item', {
    class: {
      'active': _vm.isActive('/products')
    },
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/products');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": _vm.isActive('/products') ? 'primary' : 'black'
    }
  }, [_vm._v("mdi-package-variant")])], 1), _c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('navigation_products')))])], 1), _vm.totalCodesCount ? _c('v-list-item', {
    class: {
      active: _vm.isActive('/gallery')
    },
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/gallery');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": _vm.isActive('/gallery') ? 'primary' : 'black'
    }
  }, [_vm._v("mdi-image-multiple")])], 1), _c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('navigation_gallery')))])], 1) : _vm._e(), _c('v-list-item', {
    class: {
      active: _vm.isActive('/')
    },
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": _vm.isActive('/') ? 'primary' : 'black'
    }
  }, [_vm._v("mdi-view-dashboard")])], 1), _c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('navigation_dashboard')))])], 1), _c('v-list-item', {
    class: {
      active: _vm.isActive('/upgrade')
    },
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/upgrade?source=menu');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": _vm.isActive('/upgrade') ? 'primary' : 'black'
    }
  }, [_vm._v("mdi-credit-card-outline")])], 1), _c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('navigation_plans')))])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }